import React from "react";
import styles from "./style.module.scss";
import viewImage from "../../../../static/viewImage.jpg";
import FeedIn from "../../../components/FramerMotion/FeedIn";

const Other = () => {
  return (
    <>
      <div className={styles.section}>
        <FeedIn>
          <div className={styles.sectionInner}>
            <p>Recruitment</p>
            <h3 className={styles.title}>採用について</h3>
            <p>
              未経験でも可能です！
              <br />
              一度社内の雰囲気を見てみませんか？
            </p>
          </div>
        </FeedIn>
      </div>
      <div className={styles.imageArea}>
        <FeedIn>
          <img src={viewImage} alt="" className={styles.image} />
        </FeedIn>
      </div>
      <div className={styles.section} id="about">
        <FeedIn>
          <div className={styles.sectionInner}>
            <p>About</p>
            <h3 className={styles.title}>会社概要</h3>
            <div className={styles.textArea}>
              <p className={styles.boldText}>創立年月</p>
              <p>昭和44年1月</p>
            </div>
            <div className={styles.textArea}>
              <p className={styles.boldText}>資本金</p>
              <p>2000万円</p>
            </div>
            <div className={styles.textArea}>
              <p className={styles.boldText}>従業員数</p>
              <p>25名</p>
            </div>
            <div className={styles.textArea}>
              <p className={styles.boldText}>代表者</p>
              <p>宮沢亜希子</p>
            </div>
            <div className={styles.textArea}>
              <p className={styles.boldText}>その他</p>
              <p>ISO9001認証取得(平成14年)</p>
            </div>
            <div className={styles.textArea}>
              <p className={styles.boldText}>本社・工場</p>
              <p>〒386-1321</p>
              <p>長野県上田市保野238番地</p>
            </div>
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3212.5445673949366!2d138.19270331527787!3d36.37180898003906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601da3a8ce03e05b%3A0x41aa95dac273ed15!2z77yI5qCq77yJ44Of44Ok44K244Ov!5e0!3m2!1sja!2sjp!4v1619341290296!5m2!1sja!2sjp"
              aria-hidden="false"
              className={styles.accessMap}
            ></iframe>
          </div>
        </FeedIn>
      </div>
      <div className={styles.contractSection} id="contact">
        <FeedIn>
          <div className={styles.sectionInner}>
            <p>Contract</p>
            <h3 className={styles.title}>お問い合わせ</h3>
            <p>TEL 0268-38-5565</p>
            <p>FAX 0268-38-5711</p>
            <p>MAIL info@kk-miyazawa.co.jp</p>
          </div>
        </FeedIn>
      </div>
    </>
  );
};

export default Other;
